import { PaymentResponseType } from "@app/shared/models/userBalance";
import { environment } from "@env";

export const PRODUCT_NAME = 'ePRINTit';

export const SUCCESS_URL = environment.redirectBaseUrl + PaymentResponseType.success;
export const Error_URL = environment.redirectBaseUrl + PaymentResponseType.error;

export const BRAINTREE_BASE_URL = environment.apiBaseUrl + 'braintree/transaction';
export const AUTHORIZE_NET_BASE_URL = 'https://test.authorize.net/payment/payment';
export const WEBHOOK_HEARTLAND_URL = environment.apiBaseUrl + 'heartland/response';

// Set socket timeout (5 min)
export const SOCKET_TIMEOUT = 300000;
